import { GET_RATING_DASHBOARD_SUCCESS, GET_RATING_DASHBOARD_FAIL } from "./actionType";

const STATE_INIT = {
  res: [],
  error: [],
  list: [],
};

const ratingDashboard = (state = STATE_INIT, action) => {
  switch (action.type) {
    case GET_RATING_DASHBOARD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_RATING_DASHBOARD_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
};
export default ratingDashboard;
